import { useSnackbar } from 'notistack';

import { updateCurrentUser } from 'store/slices/auth';
import { useAsyncDispatch } from 'hooks/useAsyncDispatch';

export const useProfile = () => {
  const dispatchAction = useAsyncDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const handleUpdateProfile = (payload, callback = () => {}) => {
    dispatchAction(updateCurrentUser({ payload }), {
      onSuccess: () => {
        enqueueSnackbar('Profile has been successfully updated.');
        callback();
      },
    });
  };

  return {
    handleUpdateProfile,
  };
};
